declare global {
  interface Window {
    PLAUSIBLE_URL?: string;
    PLAUSIBLE_DOMAIN?: string;
  }
}

const resolveVar = (
  runtimeValue?: string,
  buildTimeValue?: string,
): string | undefined => {
  const runtime = runtimeValue?.trim();
  if (runtime && !runtime.startsWith("{{")) return runtime;

  const buildTime = buildTimeValue?.trim();
  if (buildTime && !buildTime.startsWith("{{")) return buildTime;
};

const getPlausibleEndpoint = (baseUrl: string): string | undefined => {
  try {
    const url = new URL(baseUrl);

    if (url.protocol !== "http:" && url.protocol !== "https:") return;

    return new URL("/api/event", url).toString();
  } catch {
    console.warn(
      "Plausible analytics is disabled: VITE_PLAUSIBLE_URL is not a valid URL.",
    );
  }
};

export const initPlausible = async (): Promise<void> => {
  const baseUrl = resolveVar(
    window.PLAUSIBLE_URL,
    import.meta.env.VITE_PLAUSIBLE_URL,
  );
  const domain = resolveVar(
    window.PLAUSIBLE_DOMAIN,
    import.meta.env.VITE_PLAUSIBLE_DOMAIN,
  );

  if (!baseUrl || !domain) return;

  const endpoint = getPlausibleEndpoint(baseUrl);
  if (!endpoint) return;

  const { init } = await import("@plausible-analytics/tracker");

  init({
    domain,
    endpoint,
    autoCapturePageviews: true,
    hashBasedRouting: false,
    captureOnLocalhost: false,
    outboundLinks: true,
    fileDownloads: true,
  });
};
